import { Modal, Container } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import Table from "../../Components/TableTemplate/BreakdownTable";
import { getPaymentByExpense, getPettyCashByExpense } from "../../Helpers/apiCalls/SalesReport/SalesReportApi";

//css
import "./Modal.css";
import { formatDateNoTime, numberFormat } from "../../Helpers/Utils/Common";

function ExpensesBreakdownModal(props) {
  const [tableData, setTableData] = useState([]); 
  const [loading, setLoading] = useState(false); 

  useEffect(() => {
    if (props.show && props.data.length > 0) {
      fetchPaymentByExpense(props.data[0]); 
    }
  }, [props.show, props.data]);

  async function fetchPaymentByExpense(payload) {
    setLoading(true);

    try {
      // Fetch regular expense payments
      const expenseResponse = await getPaymentByExpense(payload);

      // Fetch petty cash transactions
      const pettyCashResponse = await getPettyCashByExpense(payload);

      let combinedData = [];

      // Process regular expense payments
      if (expenseResponse.data && expenseResponse.data.data) {
        const expenseData = expenseResponse.data.data.map((item) => ({
          se_id: item.se_id,
          po_date: payload.type === "operating_expenses" ? formatDateNoTime(item.supplies_expense_date) : formatDateNoTime(item.project_expense_date),
          supplier: item.supplier || "N/A",
          amount: numberFormat(item.grand_total),
          payment_date: item.issued_date ? formatDateNoTime(item.issued_date) : "",
          payment_mode: item.payment_mode
            ? item.payment_mode.charAt(0).toUpperCase() + item.payment_mode.slice(1) + (item.bank_name ? ` - ${item.bank_name}` : "")
            : "",
          payment_type: payload.type,
          source: "regular" // Add source identifier
        }));
        combinedData = [...combinedData, ...expenseData];
      }

      // Process petty cash transactions
      if (pettyCashResponse.data && pettyCashResponse.data.history) {
        // Filter petty cash transactions by expense type if expense_type_id is provided
        let filteredPettyCash = pettyCashResponse.data.history;

        if (payload.expense_type_id) {
          filteredPettyCash = pettyCashResponse.data.history.filter(
            (item) => item.out_type == payload.expense_type_id
          );
        }

        const pettyCashData = filteredPettyCash.map((item) => ({
          se_id: item.id,
          po_date: formatDateNoTime(item.date),
          supplier: item.requested_by_name || "Petty Cash",
          amount: numberFormat(item.amount),
          payment_date: formatDateNoTime(item.date),
          payment_mode: "Cash",
          payment_type: "petty_cash",
          source: "petty_cash", // Add source identifier
          particulars: item.particulars || "",
          expense_type_name: item.expense_type_name || ""
        }));
        combinedData = [...combinedData, ...pettyCashData];
      }

      setTableData(combinedData);
    } catch (error) {
      setTableData([]);
    }

    setLoading(false);
  }

  function ViewButton(row) {
    if (row.payment_type === "petty_cash") {
      return (
        <div className="mx-3">
          <a
            href={`/pettycash/cashout/${row.se_id}`}
            target="_blank"
            rel="noopener noreferrer"
            className="table-button me-3 p-2 d-inline-block text-decoration-none text-center"
          >
            {`PC - ${row.se_id}`}
          </a>
        </div>
      );
    } else if (row.payment_type === "operating_expenses") {
      return (
        <div className="mx-3">
          <a
            href={`/suppliesexpenses/review/${row.se_id}`}
            target="_blank"
            rel="noopener noreferrer"
            className="table-button me-3 p-2 d-inline-block text-decoration-none text-center"
          >
            {`PO - ${row.se_id}`}
          </a>
        </div>
      );
    } else {
      return (
        <div className="mx-3">
          <a
            href={`/projectexpense/view/${row.se_id}/paid`}
            target="_blank"
            rel="noopener noreferrer"
            className="table-button me-3 p-2 d-inline-block text-decoration-none text-center"
          >
            {`PE - ${row.se_id}`}
          </a>
        </div>
      );
    }
  }


  return (
    <div>
      <Modal
        show={props.show}
        onHide={props.onHide}
        className="modal-cont-receivables"
        size={props.size}
        centered
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <div className="col-sm-12 col-6">
            <div className="col-sm-12">
              <span className="custom-modal-body-title">
                Expenses Breakdown
                {props.data.length > 0 && props.data[0].account_type_name && (
                  <span className="text-muted ms-2">- {props.data[0].account_type_name}</span>
                )}
              </span>
            </div>
            <Container fluid className="modal-cont receivableAgingContainer">
              <div className="sales-tbl receivableAging" style={{ overflowX: "auto" }}>
                <Table
                  tableHeaders={[
                    // Dynamic header based on actual data types
                    (() => {
                      const hasProjectExpenses = tableData.some(item => item.payment_type === "project_expenses");
                      const hasPettyCash = tableData.some(item => item.payment_type === "petty_cash");
                      const hasOperatingExpenses = tableData.some(item => item.payment_type === "operating_expenses");

                      if (hasProjectExpenses) {
                        return "PE NO";
                      } else if (hasPettyCash && hasOperatingExpenses) {
                        // Mixed PO and PC
                        return "PO/PC NO";
                      } else if (hasPettyCash && !hasOperatingExpenses) {
                        // All PC
                        return "PC NO";
                      } else if (hasOperatingExpenses && !hasPettyCash) {
                        // All PO
                        return "PO NO";
                      } else {
                        // Default fallback
                        return "PO/PC NO";
                      }
                    })(),
                    (() => {
                      const hasProjectExpenses = tableData.some(item => item.payment_type === "project_expenses");
                      const hasPettyCash = tableData.some(item => item.payment_type === "petty_cash");
                      const hasOperatingExpenses = tableData.some(item => item.payment_type === "operating_expenses");

                      if (hasProjectExpenses) {
                        return "PE DATE";
                      } else if (hasPettyCash && hasOperatingExpenses) {
                        // Mixed PO and PC
                        return "DATE";
                      } else if (hasPettyCash && !hasOperatingExpenses) {
                        // All PC
                        return "PC DATE";
                      } else if (hasOperatingExpenses && !hasPettyCash) {
                        // All PO
                        return "PO DATE";
                      } else {
                        // Default fallback
                        return "DATE";
                      }
                    })(),
                    "SUPPLIER",
                    "AMT",
                    "PYMT DATE",
                    "PYMT MODE"
                  ]}
                  headerSelector={[
                    "se_id",
                    "po_date",
                    "supplier",
                    "amount",
                    "payment_date",
                    "payment_mode",
                  ]}
                  tableData={tableData}
                  ViewButton={(row) => ViewButton(row)}
                  fixedHeader
                  fixedHeaderScrollHeight="40vh"
                  showLoader={loading}
                  withActionData={false}
                  className={{
                    customers: "text-text-start text-break ps-2 align-top",
                  }}
                />
              </div>
            </Container>

            <div className="col-sm-12 mt-3 d-flex justify-content-end">
              <button className="button-tertiary mr-3" onClick={props.onHide}>
                Close
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

ExpensesBreakdownModal.defaultProps = {
  title: "",
  type: "",
  size: "xl",
  withButtons: false,
  withHeader: false,
  show: () => {},
  onHide: () => {},
  onEdit: () => {},
};

export default ExpensesBreakdownModal;